const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Monster Cart: count all discounts (Kaching + codes) in drawer Savings/total
window.mu_use_totalAppliedDiscounts = true;
